/* eslint-disable complexity */
import { getUserPermissionFromResourceDetails } from '../../../utils/helperMethods';
import {
    CREATE_SESSION_SUCCESS,
    CREATE_SESSION_ERROR,
    LOGIN_SUCCESS,
    LOGIN_ERROR,
    IS_LOGGED_IN_SUCCESS,
    IS_LOGGED_IN_ERROR,
    USER_PROFILE_SUCCESS,
    USER_PROFILE_ERROR,
    LOGOUT_SUCCESS,
    LOGOUT_ERROR,
    FORGOT_PASSWORD_REQUEST,
    FORGOT_PASSWORD_SUCCESS,
    FORGOT_PASSWORD_ERROR,
    RESET_PASSWORD_REQUEST,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_ERROR,
    MARK_USER_ACTIVE_REQUEST,
    MARK_USER_ACTIVE_SUCCESS,
    MARK_USER_ACTIVE_ERROR,
    GET_USER_ACCESSIBLE_ITEMS_SUCCESS,
    GET_USER_ACCESSIBLE_ITEMS_ERROR,
    OTP_RESEND_SUCCESS,
    OTP_RESEND_ERROR,
    OTP_VALIDATE_SUCCESS,
    OTP_VALIDATE_ERROR,
    RESET_OTP_FLAG,
} from './auth.constants';

export const initialState = {
    csrfIdentifier: '',
    isLoggedIn: false,
    isLoggedInExecuted: false,
    userDetails: {},
    resourceDetails: [],
    otpDetails: {
        isSuccess: false,
        error: '',
        data: {},
    },
    otpResend: {
        isSuccess: false,
        error: '',
    },
    checkOtp: false,
    otpId: '',
    otpMail: '',
};

export const authReducer = (state = initialState, action) => {
    switch (action.type) {
        // Create Session
        case CREATE_SESSION_SUCCESS:
            return { ...state, ...action.payload };
        case CREATE_SESSION_ERROR:
            return { ...initialState };
        // Login
        case LOGIN_SUCCESS:
            return {
                ...state,
                isLoggedIn: false,
                checkOtp: true,
                otpId: action.payload.otpId || '',
                loginError: '',
                otpMail: action.payload.maskedEmail || '',
            };
        case LOGIN_ERROR:
            return { ...state, ...action.payload };
        // Is Logged In
        case IS_LOGGED_IN_SUCCESS:
            return { ...state, isLoggedInExecuted: true, ...action.payload };
        case IS_LOGGED_IN_ERROR:
            return { ...state, ...action.payload };
        // User Profile
        case USER_PROFILE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                userDetails: { ...action.payload },
            };
        case USER_PROFILE_ERROR:
            return { ...state, ...action.payload };
        // Logout
        case LOGOUT_SUCCESS:
            return {
                ...initialState,
                isLoggedInExecuted: state.isLoggedInExecuted,
                isLoggedIn: false,
                checkOtp: false,
            };
        case LOGOUT_ERROR:
            return {
                ...initialState,
                isLoggedInExecuted: state.isLoggedInExecuted,
                ...action.payload,
            };
        // Forgot Password
        case FORGOT_PASSWORD_REQUEST:
            return { ...state, forgotPasswordError: '' };
        case FORGOT_PASSWORD_SUCCESS:
            return { ...state };
        case FORGOT_PASSWORD_ERROR:
            return { ...state, ...action.payload };
        // Reset Password
        case RESET_PASSWORD_REQUEST:
            return { ...state, forgotPasswordError: '' };
        case RESET_PASSWORD_SUCCESS:
            return { ...state };
        case RESET_PASSWORD_ERROR:
            return { ...state, ...action.payload };
        // Mark User Active
        case MARK_USER_ACTIVE_REQUEST:
            return { ...state };
        case MARK_USER_ACTIVE_SUCCESS:
            return { ...state };
        case MARK_USER_ACTIVE_ERROR:
            return { ...state };
        // Get User Accessible Items
        case GET_USER_ACCESSIBLE_ITEMS_SUCCESS:
            const userPermissions = getUserPermissionFromResourceDetails(
                action.payload.resourceDetails
            );
            return {
                ...state,
                resourceDetails: userPermissions,
            };
        case GET_USER_ACCESSIBLE_ITEMS_ERROR:
            return { ...state, ...action.payload };
        case OTP_RESEND_SUCCESS:
            return {
                ...state,
                otpResend: { isSuccess: true },
                otpDetails: { isSuccess: false, data: { error: '' } },
            };
        case OTP_RESEND_ERROR:
            return {
                ...state,
                otpResend: { isSuccess: false, ...action.payload },
            };
        case OTP_VALIDATE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                checkOtp: false,
                otpDetails: { isSuccess: true, data: { ...action.payload } },
            };
        case OTP_VALIDATE_ERROR:
            return {
                ...state,
                isLoggedIn: false,
                otpDetails: { isSuccess: false, ...action.payload },
            };
        case RESET_OTP_FLAG:
            return {
                ...state,
                checkOtp: false,
            };
        default:
            return state;
    }
};
